import { Path } from 'enums';
import TrialBalanceModule from 'modules/trial-balance/trial-balance.module';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

const TrialBalancePage = () => {
  return (
    <Switch>
      <Route exact path={Path.TrialBalance} component={TrialBalanceModule} />
    </Switch>
  );
};

export default TrialBalancePage;
